 
import { cancelSubscription } from '@/actions/aloader'
import { Modal, Button, Container, ModalClose, ModalDialog, Typography } from '@mui/joy'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

export function ConfirmCancelPage() {
    const navigate = useNavigate()

    const { subscriptionId } = useParams()

    const [confirmingCancellation, setConfirmingCancellation] = React.useState(false)
    const handleSubmit = event => {
        event.preventDefault()
        setConfirmingCancellation(true)
    }
    const handleConfirmCancelClick = () => {
        cancelSubscription({ 
            subscriptionId
        }).then(() => {
            navigate('../../') 
        }).catch(e => {
            console.error(e)
        })
    }
    return (
        <form method="POST" onSubmit={handleSubmit}>
            <Container>
                <Typography level="h1" element="h1">Cancel</Typography>
                <Typography>Are you sure you want to leave?</Typography>
                <Typography>On cancelation, your plan will run out until the end of it's billing period.</Typography>
                <Typography>After that, you will be downgraded to the free plan. This will happen</Typography>
                <ul>
                    <li>
                        <Typography>Your releases will be taken down from all stores</Typography>
                    </li>
                </ul>
                <Typography>If you have any questions, please contact us.</Typography>
                <Button
                    type="submit"
                    variant="outlined"
                >Yes, cancel</Button>
                <Button
                    variant="solid"
                    onClick={() => navigate(`../billing`)}
                >
                    No, take me back
                </Button>
                <Modal open={confirmingCancellation} onClose={() => setConfirmingCancellation(false)}>
                    <ModalDialog>
                        <ModalClose />
                        <Typography>Are you sure you want to cancel?</Typography>
                        <Button
                            type="submit"
                            variant="outlined"
                            onClick={handleConfirmCancelClick}
                        >
                            Confirm cancellation
                        </Button>
                        <Button
                            variant="solid"
                            onClick={() => setConfirmingCancellation(false)}
                        >
                            No, keep my plan
                        </Button>
                    </ModalDialog>
                </Modal>
            </Container>
        </form>
    )
}

export default ConfirmCancelPage;